var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"texto-container"},[_c('div',{staticClass:"numeracao"},_vm._l((_vm.linhas),function(linha){return _c('div',{key:linha,staticClass:"hljs-comment"},[_vm._v(" "+_vm._s(linha)+" ")])}),0),_c('div',[_c('pre',{staticClass:"texto"},[_c('code',{domProps:{"innerHTML":_vm._s(_vm.textoDestacado)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }